import type { HometownNewsApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';

import { PREVIEW_SIZE } from '../../constants';
import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SectionHeader } from './SectionHeader';

export function HometownNewsPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: HometownNewsApiDto[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="동네소식"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: { q: keyword || undefined, category: 'hometown-news' },
        })}
      />
      {isLoading ? (
        <SearchContentsCardSkeletonList count={PREVIEW_SIZE} />
      ) : (
        <ul className="flex flex-col gap-12 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100">
          {items.map((item) => (
            <li key={item.hometownNewsIdIdx ?? item.hometownNewsId}>
              <SearchContentsCard
                imageSrc={item.thumbnail}
                title={item.hometownNewsName}
                content={item.summary}
                daysAgo={formatDateLabel(item.publishedAt)}
                link={ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
                  idIdx: item.hometownNewsIdIdx ?? '',
                })}
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
